var React = require('react');

function OtherIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1 -1)"},[React.createElement("path",{"d":"M20,38.5A18.5,18.5,0,1,1,38.5,20,18.521,18.521,0,0,1,20,38.5Z","fill":"#c1deff","key":0}),React.createElement("path",{"d":"M20,2A18,18,0,1,1,2,20,18.021,18.021,0,0,1,20,2m0-1A19,19,0,1,0,39,20,19,19,0,0,0,20,1Z","fill":"#66a9f4","key":1}),React.createElement("path",{"d":"M20,28a2,2,0,1,0,2,2A2,2,0,0,0,20,28Z","fill":"#fff","key":2}),React.createElement("path",{"d":"M15.5,17V15A4.5,4.5,0,0,1,20,10.5h0A4.485,4.485,0,0,1,24.5,15c0,4.694-4.5,4.793-4.5,9v2","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"3","key":3})]));
}

OtherIcon.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38"};

module.exports = OtherIcon;

OtherIcon.default = OtherIcon;
